/* ============================================================================
   FRAME SIZE SELECTOR
   ----------------------------------------------------------------------------
   Behaviour:
     1. Click a card  -> updates image/caption + selected state
                       -> drives the existing `.cl-lens-select`
                       -> scrolls to the next option inside the modal.
     2. variant:change fires elsewhere -> reverse-syncs this UI.

   No duplicate variant-switching logic — we delegate to lens-module-mw.js.
   ============================================================================ */
(function () {
  'use strict';

  function norm(s) {
    return (s || '').toString().toLowerCase().trim();
  }

  function readSizeData(wrapper) {
    var script = wrapper.querySelector('script[data-cl-frame-size-data]');
    if (!script) return [];

    try {
      var parsed = JSON.parse(script.textContent);
      return Array.isArray(parsed) ? parsed : [];
    } catch (err) {
      if (window.console) console.error('[frame-size] bad data island', err);
      return [];
    }
  }

  function findSizeEntry(data, value) {
    var target = norm(value);

    for (var i = 0; i < data.length; i++) {
      if (norm(data[i].match) === target) return data[i];
    }

    return null;
  }

  function updateVisual(wrapper, entry) {
    var visual = wrapper.querySelector('[data-cl-frame-size-visual]');
    var img = wrapper.querySelector('[data-cl-frame-size-image]');
    var caption = wrapper.querySelector('[data-cl-frame-size-caption]');

    if (!img || !caption) return;

    var hasImage = !!(entry && entry.image);

    if (hasImage) {
      img.src = entry.image;
      img.alt = entry.label ? entry.label + ' frame size illustration' : '';
      img.style.display = '';
    } else {
      img.removeAttribute('src');
      img.alt = '';
      img.style.display = 'none';
    }

    caption.textContent = entry && entry.caption ? entry.caption : '';

    if (visual) visual.hidden = !hasImage;
  }

  function setSelectedCard(wrapper, value) {
    var target = norm(value);
    var cards = wrapper.querySelectorAll('[data-cl-frame-size-card]');

    cards.forEach(function (card) {
      var match = norm(card.getAttribute('data-cl-frame-size-match'));
      var input = card.querySelector('[data-cl-frame-size-input]');

      if (match === target) {
        card.classList.add('is-selected');
        if (input && !input.checked) input.checked = true;
      } else {
        card.classList.remove('is-selected');
        if (input && input.checked) input.checked = false;
      }
    });
  }

  function findLensSelect(wrapper) {
    var rerender = wrapper.closest('product-rerender');

    if (rerender) {
      var scoped = rerender.querySelector('[data-cl-lens-select]');
      if (scoped) return scoped;
    }

    return document.querySelector('[data-cl-lens-select]');
  }

  function matchLensOptionValue(select, sizeMatchValue) {
    var target = norm(sizeMatchValue);

    for (var i = 0; i < select.options.length; i++) {
      var opt = select.options[i];
      var name = opt.getAttribute('data-option-name') || opt.textContent;

      if (norm(name) === target) return opt.value;
    }

    return null;
  }

  function getInitialSelectedValue(wrapper) {
    var checked = wrapper.querySelector('[data-cl-frame-size-input]:checked');
    if (checked) return checked.value;

    var first = wrapper.querySelector('[data-cl-frame-size-input]');
    return first ? first.value : null;
  }

  function formatMoney(cents) {
    var fmt =
      (window.Shopify && window.Shopify.money_format) ||
      (window.themeVariables && window.themeVariables.settings && window.themeVariables.settings.moneyFormat) ||
      '{{amount}}';

    var amount = (cents / 100).toFixed(2);
    var parts = amount.split('.');

    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');

    return fmt.replace(/{{\s*amount[^}]*}}/g, parts.join('.'));
  }

  function initVariantPriceDiffs(wrapper) {
    var rerender = wrapper.closest('product-rerender');
    var varScript = rerender
      ? rerender.querySelector('script[data-cl-lens-variants]')
      : document.querySelector('script[data-cl-lens-variants]');

    if (!varScript) return;

    var variants;

    try {
      variants = JSON.parse(varScript.textContent);
      if (!Array.isArray(variants) || !variants.length) return;
    } catch (e) {
      return;
    }

    var optionPos = parseInt(wrapper.getAttribute('data-cl-frame-size-option-position'), 10);
    if (!optionPos) return;

    var optionKey = 'option' + optionPos;
    var priceMap = {};

    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      var val = v[optionKey];

      if (!val) continue;

      var price = Number(v.price) || 0;

      if (priceMap[val] === undefined || price < priceMap[val]) {
        priceMap[val] = price;
      }
    }

    var globalMin = Infinity;

    for (var key in priceMap) {
      if (priceMap[key] < globalMin) globalMin = priceMap[key];
    }

    if (!isFinite(globalMin)) return;

    var cards = wrapper.querySelectorAll('[data-cl-frame-size-card]');

    for (var c = 0; c < cards.length; c++) {
      var card = cards[c];
      var match = card.getAttribute('data-cl-frame-size-match');

      if (!match || priceMap[match] === undefined) continue;

      var diff = priceMap[match] - globalMin;

      if (diff <= 0) continue;

      var nameEl = card.querySelector('.cl-frame-size__card-name');

      if (!nameEl) continue;

      var diffSpan = document.createElement('span');
      diffSpan.className = 'cl-frame-size__card-price-diff';
      diffSpan.textContent = '(' + formatMoney(diff) + ')';

      nameEl.appendChild(diffSpan);
    }
  }

  function findScrollParent(start, modal) {
    var el = start.parentElement;

    while (el) {
      var style = window.getComputedStyle(el);
      var oy = style.overflowY;

      if ((oy === 'auto' || oy === 'scroll' || oy === 'overlay') && el.scrollHeight > el.clientHeight + 1) {
        return el;
      }

      if (modal && el === modal) break;

      el = el.parentElement;
    }

    return modal ? modal.querySelector('.cl-lens-modal__panel') || modal : document.scrollingElement || document.documentElement;
  }

  function scrollElementIntoModalView(target, modal) {
    if (!target) return;

    var scrollContainer = findScrollParent(target, modal);
    var elRect = target.getBoundingClientRect();
    var containerRect = scrollContainer.getBoundingClientRect();
    var offset = scrollContainer.scrollTop + (elRect.top - containerRect.top) - 18;

    if (offset < 0) offset = 0;

    if (typeof scrollContainer.scrollTo === 'function') {
      scrollContainer.scrollTo({ top: offset, behavior: 'smooth' });
    } else {
      scrollContainer.scrollTop = offset;
    }
  }

  function findNextLensOptionTarget(wrapper) {
    var modal = wrapper.closest('[data-cl-lens-modal]') || document.querySelector('[data-cl-lens-modal].is-open');
    var scope = modal || document;

    var easifyContainer = scope.querySelector('.easify-product-options');
    if (!easifyContainer) return null;

    var options = Array.prototype.slice.call(
      easifyContainer.querySelectorAll('.tpo_option-container')
    );

    var visibleOptions = options.filter(function (el) {
      return !el.classList.contains('tpo_hidden') && el.offsetParent !== null;
    });

    if (visibleOptions.length) return visibleOptions[0];

    return easifyContainer;
  }

  function scrollToNextLensOption(wrapper) {
    var modal = wrapper.closest('[data-cl-lens-modal]') || document.querySelector('[data-cl-lens-modal].is-open');
    var target = findNextLensOptionTarget(wrapper);

    if (!target) return;

    requestAnimationFrame(function () {
      setTimeout(function () {
        scrollElementIntoModalView(target, modal);
      }, 120);
    });
  }

  function wire(wrapper) {
    if (wrapper.dataset.clFrameSizeWired === '1') return;
    wrapper.dataset.clFrameSizeWired = '1';

    var data = readSizeData(wrapper);
    if (!data.length) return;

    var lensSelect = findLensSelect(wrapper);

    var initialValue = getInitialSelectedValue(wrapper);

    if (initialValue) {
      updateVisual(wrapper, findSizeEntry(data, initialValue));
      setSelectedCard(wrapper, initialValue);
    }

    wrapper.addEventListener('change', function (event) {
      var input = event.target.closest && event.target.closest('[data-cl-frame-size-input]');
      if (!input) return;

      var value = input.value;
      var entry = findSizeEntry(data, value);

      updateVisual(wrapper, entry);
      setSelectedCard(wrapper, value);

      if (lensSelect) {
        var optionValue = matchLensOptionValue(lensSelect, value);

        if (optionValue !== null && lensSelect.value !== optionValue) {
          lensSelect.value = optionValue;
          lensSelect.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }

      scrollToNextLensOption(wrapper);
    });

    var rerender = wrapper.closest('product-rerender') || document;

    rerender.addEventListener('variant:change', function (event) {
      var detail = event.detail || {};
      var variant = detail.variant;

      if (!variant) return;

      var pos = parseInt(wrapper.getAttribute('data-cl-frame-size-option-position'), 10);

      if (!pos) return;

      var optionValue = variant['option' + pos];

      if (!optionValue) return;

      var entry = findSizeEntry(data, optionValue);

      if (!entry) return;

      updateVisual(wrapper, entry);
      setSelectedCard(wrapper, entry.match);
    });

    initVariantPriceDiffs(wrapper);
  }

  function init() {
    document.querySelectorAll('[data-cl-frame-size]').forEach(wire);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();